<template>
  <div class="fixed z-10 top-0 pt-2 pl-3">
    <h1
      v-if="!!content"
      class="hidden-title filter select-none text-mobile lg:text-laptop 2xl:text-copy max-w-title"
      v-text="content.fields.pageTitle"
    />
  </div>
</template>

<script>
import { getGlobal } from "@/utils/IO";

export default {
  name: "Title",

  data: () => ({
    content: null
  }),

  async created() {
    this.content = await getGlobal();

    document.title = this.content.fields.pageTitle;
  }
};
</script>

<style scoped>
/** REMOVED THIS FEATURE */
/* .text-white .hidden-title {
  background-color: white;
} */

/* .text-black .hidden-title {
  background-color: black;
} */

/* .text-white .hidden-title:hover,
.text-black .hidden-title:hover {
  background-color: unset;
} */

/** To match the text colour transition in utils */
/* .hidden-title {
  transition: 0.5s background-color;
} */

.max-w-title {
  max-width: calc(100vw - 100px);
}
</style>
